import React from 'react'
import { formTypeList } from '../../constants/form'
import SubmitForm from './SubmitForm'

const AddNew = ({ setOpen }) => {
    return <SubmitForm formType={formTypeList.NEW} setOpen={setOpen} />
}

export default AddNew
